import type { TableOrdering } from "@/components/BaseTable.vue"
import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

export const BASE_NOTIFICATIONS_QUERY_KEY = "notifications"

export type ListNotificationsResponseItem = {
  id: string
  fromDatetime: Date
  untilDatetime: Date
  sendToTerminal: boolean
  sendToPortal: boolean
  terminalViewCount: number
  portalViewCount: number
  contents: string
  createdAt: Date
  viewedCount: number
  isActive: boolean
}

export type ListNotificationsOrdering =
  | "createdAt"
  | "fromDatetime"
  | "untilDatetime"

export type ListNotificationsQuery = Pagination & {
  ordering?: TableOrdering<ListNotificationsOrdering>
}

const listNotifications = async (
  query?: ListNotificationsQuery
): Promise<Paginate<ListNotificationsResponseItem[]>> => {
  const { body } = await api.get<
    Paginate<
      RecursivelyConvertDatesToStrings<ListNotificationsResponseItem>[]
    >
  >("/notifications/", { query })

  return {
    ...body,
    items: body.items.map((notification) => ({
      ...notification,
      createdAt: DateFns.parseISO(notification.createdAt),
      fromDatetime: DateFns.parseISO(
        notification.fromDatetime
      ),
      untilDatetime: DateFns.parseISO(
        notification.untilDatetime
      ),
    })),
  }
}

export const useNotifications = (
  query?: MaybeRef<ListNotificationsQuery | undefined>,
  enabled: MaybeRef<boolean> = true
) =>
  useQuery({
    queryKey: [
      BASE_NOTIFICATIONS_QUERY_KEY,
      query,
    ] as const,
    enabled,
    queryFn: ({ queryKey: [_, query_] }) =>
      listNotifications(unref(query_)),
    keepPreviousData: true,
  })
